import { render, staticRenderFns } from "./ImageUploadComponent.vue?vue&type=template&id=05e4e28e&"
import script from "./ImageUploadComponent.vue?vue&type=script&lang=js&"
export * from "./ImageUploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports